"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Drawer_exports = {};
__export(Drawer_exports, {
  Drawer: () => Drawer,
  default: () => Drawer_default
});
module.exports = __toCommonJS(Drawer_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_drawer = require("@react-navigation/drawer");
var import_react = __toESM(require("react"), 1);
var import_withLayoutContext = require("./withLayoutContext");
var DrawerNavigator = (0, import_drawer.createDrawerNavigator)().Navigator;
var RNDrawer = (0, import_withLayoutContext.withLayoutContext)(DrawerNavigator);
var DrawerWithRender = /* @__PURE__ */ import_react.default.forwardRef(function(props, ref) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(RNDrawer, {
    ...props,
    ref
  });
});
var Drawer = Object.assign(DrawerWithRender, {
  Screen: RNDrawer.Screen
});
var Drawer_default = Drawer;
//# sourceMappingURL=Drawer.js.map
